import { useState, useEffect } from "react";
import { Form, message } from "antd";
import {
  fetchProjectData,
  fetchCategories,
  submitIssueReport,
} from "PlatForms/OrgLMS/Services/LearnerService/trainingDetailService";

export const useTrainingDetail = (trainingId) => {
  const [projectData, setProjectData] = useState(null);
  const [memberId, setMemberId] = useState();
  const [loading, setLoading] = useState(true);
  const learnerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const [form] = Form.useForm();

  const [formVisible, setFormVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [catLoading, setCatLoading] = useState({});
  const [groupMemberId, setGroupMemberId] = useState(null);

  const fetchProjects = async () => {
    try {
      console.log("Fetching project data for trainingId:", trainingId);
      const data = await fetchProjectData(trainingId, learnerId, token);
      console.log("Fetched project data:", data);

      setProjectData(data);

      //  Safely check group
      if (data?.group?.ownMemberId) {
        setMemberId(data.group.ownMemberId);

        if (
          data.group.ownSubmitedRating === null &&
          data.group.ownSubmitedFeedBack === null
        ) {
          setGroupMemberId(data.group.ownMemberId);
        }
      }

      //  Log all course items
      if (data?.course) {
        console.log("Course Data:", data.course);
        console.log("Course ID:", data.course.id || "No course id found");
        console.log("Course Files:", data.course.courseFiles || []);
        console.log("All Course Properties:", Object.keys(data.course));
      } else {
        console.warn("No course data in API response");
      }

      return data;
    } catch (error) {
      console.error("Error fetching project data:", error);
      message.error("Error fetching project data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
    loadCategories();
  }, [trainingId]);

  const loadCategories = async () => {
    try {
      console.log("Fetching categories...");
      const data = await fetchCategories(token);
      console.log("Categories fetched:", data);
      setCategories(data);
    } catch (error) {
      console.error("Failed to load categories:", error);
      message.error("Failed to load categories");
    } finally {
      setCatLoading(false);
    }
  };

  const handleCategoryChange = (categoryId) => {
    const selected = categories.find((cat) => cat.id === categoryId);
    console.log("Selected Category:", selected);
    setSelectedCategory(selected);
    setQuestions(selected ? selected.questions : []);
  };

  const handleCategorySubmit = async (values) => {
    const formattedQuestions = questions.map((q, index) => ({
      question: q,
      answer: values[`question_${index}`] || "",
    }));

    const requestData = {
      memberId: memberId,
      trainingId: trainingId,
      categoryId: selectedCategory?.id || "",
      questions: formattedQuestions,
    };

    try {
      setSubmitting(true);
      console.log("Submitting issue report:", requestData);
      await submitIssueReport(requestData);
      message.success("Issue reported successfully!");
      setFormVisible(false);
      form.resetFields();
    } catch (error) {
      console.error("Failed to submit issue:", error);
      message.error("Failed to submit issue!");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    groupMemberId,
    setGroupMemberId,
    form,
    projectData,
    loading,
    fetchProjects,
    formVisible,
    submitting,
    catLoading,
    handleCategoryChange,
    handleCategorySubmit,
    categories,
    setFormVisible,
    questions,
  };
};

